import React, { Component } from "react";
import {
  Card,
  FlatButton,
  Divider,
  CardTitle,
  Dialog,
  TextField,
  DialogTitle,
  Snackbar,
  Alert,
} from "material-ui";
import Loading from "../Loading";
import { Link } from "react-router";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";

export default class AddCompany extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      company: this.props.company,
      toastOpen: false,
      responseMsg: "",
      address: "",
    };
  }

  componentWillReceiveProps(props) {
    if (props.company && Object.keys(props.company).length !== 0) {
      //props.clearCompanyData();
      this.setCurrentCompany(props.company);
    } else if (props.open) {
      //props.clearCompanyData();
      this.showAddCompany(props.open);
    }
  }

  setCurrentCompany = (company) => {
    this.setState({ company: company, open: true });
  };

  showAddCompany = (open) => {
    this.setState({ open: open });
  };

  handleChange = (address) => {
    let { company } = this.state;
    company.address = address;
    this.setState({ company: company });
  };

  handleSelect = (address) => {
    let { company } = this.state;
    company.address = address;
    this.setState({ company: company });
  };

  notifyFormError(data, msg) {
    console.error("Form error:", data);
    alert(msg);
  }

  addCompany = () => {
    let { company } = this.state;
    var me = this;
    let companyId = company.companyId;
    let companyName = company.company;
    let contactNumber = company.contactNumber;
    let address = company.address;
    let checkValue = this.checkValidation();
    if (checkValue) {
      return;
    }
    let body = {
      companyId: companyId,
      companyName: companyName,
      contactNumber: contactNumber,
      address: address,
    };

    let url = `/api/payroll/addCompany`;
    let options = {
      method: "POST",
      headers: {
        token: this.props.token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    };
    fetch(url, options)
      .then((res) => {
        if (res.status >= 200 && res.status < 300) {
          return res.json();
        } else {
          this.notifyFormError(res, "Internal server error.");
          this.setState({ open: false });
        }
      })
      .then((json) => {
        if (json.message == "Company already exist.") {
          this.notifyFormError(json, "Company is already exist.");
        } else {
          me.setState({ open: false });
          this.props.closeAddCompanyPopup();
          me.props.updateCompanyData(json.company);
        }
      });
  };

  updateCompany = () => {
    let { company } = this.state;
    let me = this;
    let companyId = company.companyId;
    let companyName = company.company;
    let contactNumber = company.contactNumber;
    let address = company.address;
    let checkValue = this.checkValidation();
    if (checkValue) {
      return;
    }
    let body = {
      companyId: companyId,
      companyName: companyName,
      contactNumber: contactNumber,
      address: address,
    };
    let url = `/api/payroll/editCompany`;
    let options = {
      method: "PUT",
      headers: {
        token: this.props.token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    };
    fetch(url, options).then((res) => {
      if (res.status >= 200 && res.status < 300) {
        if (res.message == "Company already exist.") {
          this.notifyFormError(res, "Company is already exist.");
        } else {
          me.setState({ open: false });
          this.props.closeAddCompanyPopup();
          me.props.updateCompanyData(json.company);
        }
      } else {
        this.notifyFormError(res, "Internal server error.");
        this.setState({ open: false });
      }
    });
  };

  checkValidation() {
    let { company } = this.state;
    if (company.companyId == "" || company.companyId == null) {
      alert("Please enter clientId");
      return true;
    } else if (company.company == "" || company.company == null) {
      alert("Please enter company name");
      return true;
    } else {
      return false;
    }
  }

  closeCompanyModal = () => {
    this.setState({ open: false, company: {} });
    this.props.closeAddCompanyPopup();
  };

  onChangeValue = (key, value) => {
    let { company } = this.state;
    if (key == "companyId") {
      company.companyId = value;
    } else if (key == "company") {
      company.company = value;
    } else if (key == "contactNumber") {
      company.contactNumber = value;
    } else if (key == "address") {
      company.address = value;
    }
    this.setState({ company: company });
  };

  render() {
    let { toastOpen, responseMsg, open, company } = this.state;
    return (
      <div>
        <Dialog open={open}>
          <Card className="addCompanyHeader">
            {company.companyId ? (
              <CardTitle title="Edit Company" />
            ) : (
              <CardTitle title="Add Company" />
            )}
          </Card>
          <TextField
            value={company.companyId}
            disabled={this.props.company.companyId ? true : false}
            floatingLabelText="Client Id"
            style={{ width: "22rem", marginTop: "20px" }}
            onChange={(e) => this.onChangeValue("companyId", e.target.value)}
          />
          <TextField
            value={company.company}
            floatingLabelText="Company Name"
            style={{ width: "22rem", marginLeft: "20px" }}
            onChange={(e) => this.onChangeValue("company", e.target.value)}
          />
          <TextField
            value={company.contactNumber}
            floatingLabelText="Contact Number"
            type="phone"
            style={{ width: "22rem", marginLeft: "20px" }}
            onChange={(e) =>
              this.onChangeValue("contactNumber", e.target.value)
            }
          />
          <br />
          <PlacesAutocomplete
            value={company.address}
            onChange={this.handleChange}
            onSelect={this.handleSelect}
          >
            {({
              getInputProps,
              suggestions,
              getSuggestionItemProps,
              loading,
            }) => (
              <div
                style={{
                  width: "97.5%",
                  borderRadius: "0px",
                  marginTop: "2rem",
                }}
              >
                <input
                  {...getInputProps({
                    placeholder: "Company Address",
                    className: "location-search-input",
                  })}
                  className="addressField"
                  ref="address"
                />
                <div className="autocomplete-dropdown-container">
                  {loading && <div>Loading...</div>}
                  {suggestions.map((suggestion) => {
                    const className = suggestion.active
                      ? "suggestion-item--active"
                      : "suggestion-item";
                    // inline style for demonstration purpose
                    const style = suggestion.active
                      ? { backgroundColor: "#fafafa", cursor: "pointer" }
                      : { backgroundColor: "#ffffff", cursor: "pointer" };
                    return (
                      <div
                        {...getSuggestionItemProps(suggestion, {
                          className,
                          style,
                        })}
                      >
                        <span>{suggestion.description}</span>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </PlacesAutocomplete>
          <br />
          <div style={{ float: "right" }}>
            <FlatButton
              className="c-btn__secondary"
              type="cancel"
              onTouchTap={this.closeCompanyModal}
            >
              Close
            </FlatButton>
            {company._id ? (
              <FlatButton type="submit" onTouchTap={this.updateCompany}>
                Update
              </FlatButton>
            ) : (
              <FlatButton type="submit" onTouchTap={this.addCompany}>
                Add
              </FlatButton>
            )}
          </div>
        </Dialog>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/documentUploader/AddCompany.js